// extracted by mini-css-extract-plugin
export default {"footerCta":"_R2CaaqZCberPIfQa53x","footerIconContainer":"ClbGAuRAAuwMyzlTLkaK"};